<nb-card [nbSpinner]="loading" nbSpinnerStatus="primary" class="card-box">
    <nb-card-header class="content-header">
        <span class="title">{{featureNameTranslated()}}</span>
        <nb-icon class="close" icon="close-outline" (click)="cancel()"></nb-icon>
    </nb-card-header>
    <nb-card-body class="content-body">
        <div class="picture-box">
            <img src="assets/modals/update_firmware.jpg" alt="roboze-photo">
        </div>
        <div class="attention-box">
            <div class="attention-box__icon">
                <nb-icon icon="alert-circle-outline" status="danger"></nb-icon>
            </div>
            <p class="attention-box__text">
                {{'common.install-latest-firmware' | translate:{'option': featureNameTranslated() } }}
            </p>
        </div>
        <div class="description-box">
            <h3 class="description-box__title">
                {{featureName | translate}}
            </h3>
            <p class="description-box__text">
                {{featureDescription | translate}}
            </p>
        </div>
    </nb-card-body>
    <nb-card-footer class="content-footer">
        <button nbButton [size]="'large'" [status]="'control'" [appearance]="'outline'"
                (click)="cancel()" tabindex="-1">
            {{'common.cancel' | translate}}
        </button>
        <button nbButton [status]="'primary'" [size]="'large'"
                (click)="updateDevice()" tabindex="-1">
            {{'common.update' | translate}}
        </button>
    </nb-card-footer>
</nb-card>